<template>
  <div>
    <!-- <v-row style="margin-top: -75px;"> -->
    <v-row>
      <v-spacer></v-spacer>
      <v-col class="text-right">
        <v-dialog v-model="dialog" persistent max-width="600px">
          <!-- <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark rounded small class="mx-2" v-bind="attrs" v-on="on">
              Create User Roles
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template> -->
          <v-card>
            <v-card-title>
              <span class="headline">Create New Role</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      aria-autocomplete="off"
                      label="Name*"
                      v-model="name"
                      required
                      hint="Make sure it's easy to remember"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      aria-autocomplete="off"
                      label="Description*"
                      v-model="description"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" v-if="errorMessage">
                    <h3 class="text-center red--text">{{ errorMessage }}</h3>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close()">Close</v-btn>
              <v-btn color="blue darken-1" text @click="saveNewPosition" :disabled="disableSave">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <loading-overlay v-if="loading"/>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Swal from 'sweetalert2';
import LoadingOverlay from "./common/LoadingOverlay.vue";

export default {
  name: "PositionModal",
  props: {
    dialog: Boolean
  },
  components: {
    LoadingOverlay,
  },
  data() {
    return {
      disableSave: false,
      loading: false,
      name: "",
      description: "",
      errorMessage: null,
      type: "Office",
      status: "Active",
    };
  },
  methods: {
    ...mapActions(["createPosition"]),
    async saveNewPosition() {
      this.disableSave = true;
      this.loading = true
      const body = {
        name: this.name,
        description: this.description,
      };
      const create = await this.createPosition(body);
      if(create.error) {
        this.disableSave = false;
        this.loading = false
        if(create.status == 400) this.errorMessage = create.message;
        else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Internal Server Error',
          })
        }
      } else if(create) {
        this.disableSave = false;
        this.loading = false
        this.name = '';
        this.description = '';
        this.$emit("closeDialog", true)
        this.errorMessage = null;
      }
    },
    close() {
      this.$emit("closeDialog", false)
      this.errorMessage = false;
      this.name = '';
      this.description = '';
    }
  },
};
</script>

<style>
</style>